import React from "react";
import { Roles } from "../../constants/data/Roles";
import { useAuth } from "../../context/AuthProvider";
import UserManagement from "./UserManagement";
import { ClinicUserManagement } from "./ClinicDetails/ClinicUserManagement/ClinicUserManagement";

export default function ClinicManagement() {
  const auth = useAuth();
  return (
    <>
      {auth?.authClaims?.role.toUpperCase() === Roles.supportUser ? (
        <UserManagement />
      ) : (
        <ClinicUserManagement />
      )}
    </>
  );
}
